import { userName, userID, eventID, headshot } from "../../utils/datalayer"
import { useState } from "preact/hooks"
import Leaderboard from "src/components/Leaderboard"

const Floating = ({ component, show = false }) => <div class={`tk-floating-header ${show ? "" : "hide"}`}>
	{component}
</div>


export const Navbar = () => {

	const [showLeaderboard, setShowLeaderboard] = useState(false)

	const toggle = (vl, setter) => {
		return () => {
			setter(!vl)
		}
	}

	return <div class="topnavtk2" id="myTopnavtk2">
		<a href="https://www.tkeventsregistration.com/coffee-demo" id="LeaveEvent" class="activetk2">Leave</a>
		<div class="dropdowntk2">
			<button class="dropbtntk2">Venue
				<i class="fa fa-caret-down" />
			</button>
			<div class="dropdown-contenttk2">
				<a href="/" title="Return to Lobby">Lobby</a>

				<a href="/The-Lounge" title="The Lounge">The Lounge</a>
				<a href="/Coffee-Talks" title="Coffee Talks">Coffee Talks</a>
				<a href="/The-Forum" title="The Forum">The Forum</a>
			</div>
		</div>
		<div>
			<div class="dropdowntk2">
				<button onClick={toggle(showLeaderboard, setShowLeaderboard)} class="dropbtntk2">Leaderboard
					<i class="fa fa-caret-down" />
				</button>
				{<Floating show={showLeaderboard} component={
					<Leaderboard
						userId={userID}
						eventId={eventID}
						name={userName}
						headshot = {headshot}
						entrypoint="https://leaderboardb.swoogo-retrofit.tkevents.io"
						poolingSec={3} />
				} />}
			</div>
		</div>

		<a onclick={window.openSupport} title="Help Desk">Help Desk</a>
	</div>
}
